import { createContext, useContext, useReducer } from 'react';
import userReducer from '../reducer/userReducer';
import useAsyncDispatchUser from '../middleware/useAsyncDispatchUser';

const UserContext = createContext(null);
const UserDispatchContext = createContext(null);

export function UserProvider({ config, children }) {
  const [userContext, dispatch] = useReducer(
    userReducer,
    {
      ...config
		}
  );

  const asyncDispatch = useAsyncDispatchUser(userContext, dispatch);

  return (
    <UserContext.Provider value={userContext}>
      <UserDispatchContext.Provider value={asyncDispatch}>
        {children}
      </UserDispatchContext.Provider>
    </UserContext.Provider>
  );
}

export function useUser() {
  return useContext(UserContext);
}

export function useUserDispatch() {
  return useContext(UserDispatchContext);
}
